import { render, staticRenderFns } from "./aside_menu_cache.vue?vue&type=template&id=b541bff2&scoped=true&"
import script from "./aside_menu_cache.vue?vue&type=script&lang=js&"
export * from "./aside_menu_cache.vue?vue&type=script&lang=js&"
import style0 from "./aside_menu_cache.vue?vue&type=style&index=0&lang=css&"
import style1 from "./aside_menu_cache.vue?vue&type=style&index=1&id=b541bff2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b541bff2",
  null
  
)

export default component.exports